export const animals = [
    {
        animalId: "123456",
        animalName: "Pumba",
        animalSpecieId: "1",
        groupId: "1",
        zooId: "1",
        zimsID: "",
        evals: ["ID1", "ID2"],
        enclosureId: [],
        animalsBiology: {},
    },
    {
        animalId: "123455",
        animalName: "Timon",
        animalSpecieId: "2",
        groupId: "1",
        zooId: "1",
        zimsID: "",
        evals: ["ID1", "ID2"],
        enclosureId: [],
        animalsBiology: {},
    }
]


export const species = [{
    specieId: "1",
    specieName: "foo",
    specieSurveyWhiteList: ["ID1", "ID2"]
}, {
    specieId: "2",
    specieName: "bar",
    specieSurveyWhiteList: ["ID3"]
}]



